var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmcFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04557 2.75C3.53931 2.75 3.12891 3.16041 3.12891 3.66667V18.3333C3.12891 18.8396 3.53931 19.25 4.04557 19.25H10.4622V13.75H6.79557V8.25H10.4622V2.75H4.04557Z",
    fill: "#EC6535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8789 2.75H18.7122C19.2185 2.75 19.6289 3.16041 19.6289 3.66667V18.3333C19.6289 18.8396 19.2185 19.25 18.7122 19.25H16.8789V2.75Z",
    fill: "#EC6535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6375 10.6759C15.8165 10.8549 15.8165 11.1451 15.6375 11.3241L11.8366 15.125V12.375H8.16992V9.625H11.8366V6.875L15.6375 10.6759Z",
    fill: "#EC6535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmcFill);
export default __webpack_public_path__ + "static/media/smc_fill.27eba5abeec9db624910ec7f845f37dd.svg";
export { ForwardRef as ReactComponent };